var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaticanCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 -0.00012207C31.0456 -0.00012207 40 8.95425 40 19.9999C40 31.0455 31.0456 39.9999 20 39.9999C20 39.1303 17.3913 19.9999 17.3913 19.9999L20 -0.00012207Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9999C8.9544 39.9999 3.05176e-05 31.0455 3.05176e-05 19.9999C3.05176e-05 8.95425 8.9544 -0.00012207 20 -0.00012207",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6586 17.4033L31.4173 22.3757C30.8251 23.2724 30.8282 24.4805 31.5132 25.3865C32.3819 26.5358 34.0179 26.7633 35.1673 25.8945C36.3166 25.0258 36.5441 23.3897 35.6752 22.2404C34.9904 21.3344 33.8289 21.0019 32.8046 21.3271L26.9467 13.5776L25.5594 14.6264L23.4781 16.1994L25.5757 18.974L27.6586 17.4033ZM33.0698 23.1197C33.4529 22.8301 33.9983 22.906 34.2879 23.289C34.5774 23.6721 34.5017 24.2175 34.1186 24.5072C33.7356 24.7966 33.1902 24.721 32.9007 24.3378C32.6109 23.9547 32.6867 23.4093 33.0698 23.1197V23.1197Z",
    fill: "#ACABB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1054 18.974L36.2029 16.1994L34.1218 14.6263L32.7345 13.5775L26.8766 21.327C25.8525 21.0018 24.6909 21.3344 24.006 22.2403C23.1371 23.3897 23.3646 25.0256 24.5139 25.8944C25.6633 26.7631 27.2992 26.5357 28.168 25.3864C28.8528 24.4804 28.8559 23.2723 28.2638 22.3756L32.0225 17.4032L34.1054 18.974ZM26.7806 24.3378C26.4911 24.721 25.9458 24.7967 25.5627 24.5072C25.1795 24.2175 25.1038 23.6721 25.3934 23.289C25.6829 22.906 26.2283 22.8301 26.6115 23.1198C26.9945 23.4094 27.0702 23.9548 26.7806 24.3378V24.3378Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaticanCity);
export default __webpack_public_path__ + "static/media/vatican_city.ee42d8832e30994fe0cec761045b8c07.svg";
export { ForwardRef as ReactComponent };